var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.007 9H21.8212C21.044 9 20.4141 10.1668 20.4141 11.6061V40.3939C20.4141 41.8332 21.044 43 21.8212 43H46.007C46.7841 43 47.4141 41.8332 47.4141 40.3939V11.6061C47.4141 10.1668 46.7841 9 46.007 9Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94939 9.75H45.0506C45.946 9.75 46.75 10.5365 46.75 11.6061V40.3939C46.75 41.4635 45.946 42.25 45.0506 42.25H2.94939C2.05399 42.25 1.25 41.4635 1.25 40.3939V11.6061C1.25 10.5365 2.05399 9.75 2.94939 9.75Z",
    stroke: "#003D6A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3636 9H29.4727V43H45.3636C46.5317 43 47.4727 41.8272 47.4727 40.3939V11.6161C47.4727 10.1727 46.5236 9.01 45.3636 9.01V9Z",
    fill: "#0098C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0173 18.04H7.52734",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7361 18.04H33.2461",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2461 20.54H36.7361",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52734 20.54H11.0173",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5875 6.04001C28.3975 3.09001 25.5175 1 22.1375 1C18.7575 1 15.8775 3.09001 14.6875 6.04001",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27734 23.3701V39.5601",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9961 23.3701V39.5601",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27734 11.2598V15.7898",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9961 11.2598V15.7898",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.ccad2236b1243c7f2b84522c5f7ebda3.svg";
export { ForwardRef as ReactComponent };